module.exports = __webpack_public_path__ + "img/m-guide-main.803ac0bb.png";